<template lang="pug">
div.list.curriculum-list.media-list
  sent-curriculums-query(:studentId="studentId")
    template(slot-scope="{ sentCurriculums }")
      ul
        sent-curriculum-list-item(
          v-for="curriculum in sentCurriculums"
          :key="curriculum.id"
          :curriculum="curriculum"
          @click="$emit('click', curriculum.id)")
</template>

<style lang="scss" scoped>
.curriculum-list {
  margin: 0;
  padding-bottom: 40px;
}
</style>

<script>
import SentCurriculumsQuery from '@/components/queries/SentCurriculumsQuery'
import SentCurriculumListItem from '@/components/molecules/SentCurriculumListItem'

export default {
  props: {
    studentId: String,
  },
  components: {
    SentCurriculumsQuery,
    SentCurriculumListItem,
  },
}
</script>
